var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "chat-selector" },
    [
      _c(
        "AppDropdownMenu",
        {
          ref: "chat-dropdown",
          staticClass: "chat-dropdown-menu",
          attrs: {
            options: _vm.chatOptions,
            rightAlign: false,
            dropdownAutoClose: true,
            currentValue: _vm.currentChat,
            minWidth: 0
          },
          on: {
            selected: _vm.handleChatSelect,
            showDropdown: _vm.handleShowDropdown,
            hideDropdown: _vm.handleHideDropdown
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "chat-selector-trigger",
              on: { click: _vm.toggleDropdown }
            },
            [
              _c("div", { staticClass: "chat-title" }, [
                _vm._v(_vm._s(_vm.currentChatTitle))
              ]),
              _vm._v(" "),
              _c("InlineSvg", {
                staticClass: "dropdown-icon",
                class: { rotated: _vm.isDropdownOpen },
                attrs: { src: "/images/dropdown-arrow.svg" }
              })
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }